import Resource from './Resource';

export default class FeesHeader extends Resource {
	constructor(options={}) {
		let {
			route = 'fees/description',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
